import * as React from 'react';
import { TextInput } from 'react-admin';

export const postFilters = [
    <TextInput label="Search" source="q" alwaysOn />,
];